<template>
  <div class="title-box">
    <SearchResultCount
      v-if="hasCount"
      :category="category"
      :total-count="totalCount"
    />
    <div v-if="hasFilterList" class="filter-wrap">
      <FilterList :filter="filter" />
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import SearchResultCount from '@/components/search/view/SearchResultCount'
  import FilterList from '@/pages/list/FilterList'

  export default {
    name: 'SearchResultListTitle',
    components: {
      SearchResultCount,
      FilterList,
    },
    props: {
      category: {
        type: String,
        default: '',
      },
      totalCount: {
        type: Number,
        default: 0,
      },
      filter: {
        type: Object,
        default: null,
      },
    },
    computed: {
      hasCount() {
        return this.totalCount > 0
      },
      hasFilterList() {
        return _.get(this.filter, 'filterlist', []).length > 0
      },
    },
  }
</script>
<style lang="scss" scoped>
  .title-box {
    margin: 0 100px 20px;
  }
</style>
